import React from "react";
import { Input, Button, Form, Col, Row } from "reactstrap";
import DateRangePicker from "components/DateRangePicker";
import AffiliateTable from "./AffiliateTable";

// API
import { useGetDashboardAffiliateQuery, useLazyExportDashboardAffiliatesQuery } from "services/dashboard/api";

// Utils
import { downloadFile, generateTimestampedFilename } from "utils/fileUtils";

// Icons
import { ReactComponent as XlsIcon } from "assets/icons/xls.svg";

// Hooks
import useTableController from "hooks/useTableController";

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

const AffiliateTab = () => {
  // FORM
  const { formik, searchInput, setSearchInput, handleTableChange, handleDateRangeChange } = useTableController({
    initialValues: {
      dateRange: {
        // Keep 7-day window but end at yesterday
        startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
        endDate: new Date(new Date().setDate(new Date().getDate() - 1)),
      },
    },
    validationSchema: SearchFilterSchema,
  });

  // API
  const { data, error, isLoading } = useGetDashboardAffiliateQuery(formik.values);
  const [exports] = useLazyExportDashboardAffiliatesQuery();

  // ACTION
  const onExport = async () => {
    try {
      const response = await exports(formik.values);
      const fileName = generateTimestampedFilename("products-affiliate");
      await downloadFile(response.data, fileName);
    } catch (error) {
      console.error("Export failed:", error);
    }
  };

  // RENDER
  return (
    <Form className="form-horizontal w-100 d-flex flex-column gap-4" onSubmit={formik.handleSubmit} data-testid="search-form">
      <div className="affiliate-container" data-testid="tab-affiliate">
        <div className="header mt-4">
          <h2 className="fw-semibold">พาร์ทเนอร์ Affiliate ทั้งหมด</h2>
          <div className="d-flex flex-column gap-2">
            <Row className=" gy-3">
              <Col sm={12} md={4} lg={4}>
                <div className="datepicker">
                  <DateRangePicker
                    value={formik.values.dateRange || { startDate: null, endDate: null }}
                    onChange={handleDateRangeChange}
                    error={formik.touched.dateRange && formik.errors.dateRange}
                    useRange={true}
                    // Disallow selecting today or future; only up to yesterday
                    maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                  />
                </div>
              </Col>
              <Col sm={12} md={8} lg={{ offset: 1, size: 7 }}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input name="searchTerm" type="text" placeholder="ค้นหารายการพาร์ทเนอร์" onChange={(e) => setSearchInput(e.target.value)} onBlur={formik.handleBlur} value={searchInput} invalid={formik.touched.searchTerm && formik.errors.searchTerm} data-testid="search-input" />
                      {formik.touched.searchTerm && formik.errors.searchTerm && (
                        <div className="error-message" data-testid="search-error">
                          {formik.errors.searchTerm}
                        </div>
                      )}
                    </div>
                  </div>

                  <Button color="success" size="xs" onClick={onExport} className="d-flex gap-2" data-testid="export-button">
                    <XlsIcon />
                    EXPORT EXCEL
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <AffiliateTable data={data} error={error} isLoading={isLoading} onTableChange={handleTableChange} />
      </div>
    </Form>
  );
};

export default AffiliateTab;
